import { styled } from '@mui/material/styles';
import React from 'react';

import { getTrialInfo, getTrialMessage } from '../../../../../utils/trialUtils';
import { TextButton } from '../../../../global/components/Button/Button';

const InfoBar = styled('div')(
    ({ theme }) => `
        background-color: ${theme.palette.primary.light};
        color: ${theme.palette.primary.main};
        border-radius: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        padding: 0.5rem;
        padding-left: 1rem;
        padding-right: 1rem;
        font-weight: 500;
        min-height: 2.5rem;
    `
);

const Subscription = ({
    company,
    jobs,
    jobSections,
    user,
    subRoleCount
}: {
    company: any;
    jobs: any;
    jobSections: any;
    user: any;
    subRoleCount: number;
}) => {
    const trialInfo = getTrialInfo(company.subscription);
    const hasValidSubscription =
        company.subscription &&
        (company.subscription.status === 'active' || trialInfo.isTrialing);

    return (
        <>
            {/* Trial banner */}
            {trialInfo.isTrialing && (
                <InfoBar>
                    {getTrialMessage(trialInfo)}
                    {!trialInfo?.hasPaymentMethod && (
                        <TextButton
                            to={`/edit/${user.userID}/business/${company.id}/plans`}
                            style={{
                                fontSize: '1rem'
                            }}
                        >
                            {'Add Payment Method'}
                        </TextButton>
                    )}
                </InfoBar>
            )}

            {/* No subscription or no jobs */}
            {(jobs.length === 0 || !hasValidSubscription) && (
                <InfoBar>
                    {!hasValidSubscription
                        ? 'Your subscription is inactive, please renew your subscription.'
                        : "You don't have any jobs postings yet. Create your first role!"}
                    {!hasValidSubscription && (
                        <TextButton
                            to={`/edit/${user.userID}/business/${company.id}/plans`}
                            style={{
                                fontSize: '1rem'
                            }}
                        >
                            {'Update Subscription'}
                        </TextButton>
                    )}
                </InfoBar>
            )}

            {/* Role limit reached */}
            {hasValidSubscription &&
                jobs.length > 0 &&
                subRoleCount <= jobSections.active.jobs.length && (
                    <InfoBar>
                        {`You have reached your active role limit of ${subRoleCount}.`}
                        <TextButton
                            to={`/edit/${user.userID}/business/${company.id}/plans`}
                            style={{
                                fontSize: '1rem'
                            }}
                        >
                            {'Update Subscription'}
                        </TextButton>
                    </InfoBar>
                )}
        </>
    );
};

export default Subscription;
